module.exports = __webpack_public_path__ + "img/system_management.b4935c76.jpg";